// extracted by css-extract-rspack-plugin
export default {"cls1":"SelectionCitation-cls1_TYP","cls2":"SelectionCitation-cls2_0TV SelectionCitation-cls1_TYP"};